import { getBrowserType } from './userAgent';

// sensors-push-origin
const SENSORS_SERVER_DEV = 'https://pxsensorsdata.pxb7.com/sa?project=default'
const SENSORS_SERVER_PROD = 'https://pxsensorsdata.pxb7.com/sa?project=production'

const isProd = process.env.VUE_APP_ENV === 'production'

const sensors = require('sa-sdk-javascript');
sensors.init({
  show_log: true,
  server_url: isProd ? SENSORS_SERVER_PROD : SENSORS_SERVER_DEV,
  is_track_single_page:true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  use_client_time:true,
  send_type:'beacon',
  heatmap: {
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap:'not_collect',
    //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map:'not_collect'
  }
});
// 注册公共属性
sensors.registerPage({
  platform_type: 'Web',
  channel_name: getBrowserType(),
  is_login: ()=> JSON.parse(localStorage.getItem('loginStatus')),
  from_share: false,
});

sensors.quick('autoTrack'); //用于采集 $pageview 事件。

sensors.quick('isReady',function(){
	const isLogin = JSON.parse(localStorage.getItem('loginStatus') || 'false')
  const userData = localStorage.getItem('userData')
  isLogin && userData && userData.includes('user_id') ? sensors.login(JSON.parse(userData).user_id)  : sensors.logout()
});

export default sensors;
